import { useContext, useEffect, useState } from 'react';
import Image from 'next/image';
import Head from 'next/head';
import styled, { css } from 'styled-components';
import { Container } from 'react-bootstrap';

import Sticky from 'react-stickynode';
import Header from '../components/Header';
import { HeaderSpacer } from '../pages/_app';
import rewriteAssetPath from '../util/rewriteAssetPath';
import MenuComponent from '../components/Menu/MenuComponent';
import RestaurantContext from '../Context/RestaurantContext';
import CartAndConfiguratorComponent from '../components/Cart/CartAndConfiguratorComponent';
import CartStripMobile from '../components/Cart/CartStripMobile';
import { useMediaQuery } from 'react-responsive';
import ClosingTimeCounter from '../components/ClosingTimeCounter';
import CartContext from '../Context/CartContext';

const TitleImageWrapper = styled.div`
  position: relative;
  display: none;
  height: 250px;
  width: 100%;
`;

const MenuPageContentWrapper = styled.div`
  display: flex;
  flex-flow: row;
`;

const MenuWrapper = styled.div`
  flex-grow: 1;
  overflow-x: auto;

  @media (min-width: 576px) {
    padding-left: 5px;
    padding-right: 5px;
  }
  @media (min-width: 992px) {
    padding-right: 25px;
  }
`;

const CartSideWrapper = styled.div`
  position: relative;
  display: none;

  width: 375px;

  flex-grow: 0;
  flex-shrink: 0;

  @media (min-width: 992px) {
    display: block;
  }
`;

const CartSide = styled.div`
  position: relative;

  width: 100%;
  min-height: calc(100vh - 250px - 64px);
  max-height: calc(100vh - 64px);
`;

const CustomContainer = styled(Container)`
  @media (max-width: 575.98px) {
    padding: 0;
  }

  ${(props) => {
    if (props.$cartHasItems) {
      return css`
        @media (max-width: 991.98px) {
          padding-bottom: 56px;
        }
      `;
    }
  }}
`;

const MenuPage = ({ ...props }) => {
  const { restaurantProps: storeProps, ...restaurantContext } = useContext(RestaurantContext);

  const {
    cart: {
      meta: { items },
    },
  } = useContext(CartContext);

  const isCartAlwaysVisibleInScreen = useMediaQuery({
    query: '(min-width: 992px)',
  });

  const [isOnClient, setIsOnClient] = useState(false);
  useEffect(() => {
    setIsOnClient(true);
  }, []);

  const title = `Speisekarte - ${storeProps.restaurantName}`;
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Container style={{ display: 'flex', justifyContent: 'end' }}>
        <ClosingTimeCounter variant="menu" />
      </Container>
      <TitleImageWrapper className="d-sm-block">
        <Image
          priority
          src={rewriteAssetPath(storeProps.titleImagePath, props.env.APP_ENV)}
          alt={`Speisekarte - ${storeProps.restaurantName}`}
          title="Speisekarte"
          fill
          sizes="100vw"
          style={{
            objectFit: 'cover',
          }}
        />
      </TitleImageWrapper>
      <CustomContainer $cartHasItems={items > 0}>
        <MenuPageContentWrapper>
          <MenuWrapper>
            <MenuComponent env={props.env} />
          </MenuWrapper>

          <CartSideWrapper>
            <Sticky top="#header">
              <CartSide>
                {isCartAlwaysVisibleInScreen && isOnClient && (
                  <CartAndConfiguratorComponent key="fullscreen-cart" />
                )}
              </CartSide>
            </Sticky>
          </CartSideWrapper>
        </MenuPageContentWrapper>
      </CustomContainer>
    </>
  );
};

MenuPage.getLayout = function PageLayout(page) {
  return (
    <>
      <Header initiallyShown />
      <HeaderSpacer />
      {page}
      <CartStripMobile />
    </>
  );
};

export default MenuPage;
